(() => {
  function initBrandDrag(root = document) {
    root.querySelectorAll('[class*="scrolling-logo-slider-"]').forEach((slider) => {
      if (slider.dataset.cosmosDragReady) return;
      const marquee = slider.querySelector('[class*="marquee-horizontal-"]');
      const tracks = marquee && [...marquee.children].filter((item) => [...item.classList].some((name) => name.startsWith('track-horizontal-')));
      if (!marquee || !tracks.length) return;
      slider.dataset.cosmosDragReady = 'true';
      slider.style.cursor = 'grab';
      slider.style.touchAction = 'pan-y';
      slider.querySelectorAll('img, a').forEach((item) => { item.draggable = false; });

      let startX = 0;
      let startOffset = 0;
      let offset = 0;
      let pressed = false;
      let dragged = false;
      let suppressClick = false;

      slider.addEventListener('dragstart', (event) => event.preventDefault());
      slider.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        pressed = true;
        dragged = false;
        startX = event.clientX;
        startOffset = offset;
      });
      slider.addEventListener('pointermove', (event) => {
        if (!pressed) return;
        const distance = event.clientX - startX;
        if (!dragged && Math.abs(distance) < 6) return;
        if (!dragged) {
          dragged = true;
          tracks.forEach((track) => { track.style.animationPlayState = 'paused'; });
          slider.setPointerCapture(event.pointerId);
          slider.style.cursor = 'grabbing';
          slider.style.userSelect = 'none';
        }
        offset = startOffset + distance;
        marquee.style.transform = `translate3d(${offset}px, 0, 0)`;
      });
      const finish = () => {
        if (!pressed) return;
        pressed = false;
        slider.style.cursor = 'grab';
        slider.style.userSelect = '';
        tracks.forEach((track) => { track.style.animationPlayState = ''; });
        if (dragged) {
          suppressClick = true;
          window.setTimeout(() => { suppressClick = false; }, 100);
        }
      };
      slider.addEventListener('pointerup', finish);
      slider.addEventListener('pointercancel', finish);
      slider.addEventListener('click', (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initBrandDrag(), { once: true });
  else initBrandDrag();
  document.addEventListener('shopify:section:load', (event) => initBrandDrag(event.target));
})();

